import { Switch, Text } from '@carnica/ui-kit';
import classNames from 'classnames/bind';
import React from 'react';
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
export var Toggle = function Toggle(_ref) {
  var onClick = _ref.onClick,
    text = _ref.text,
    iconUrl = _ref.iconUrl,
    isOn = _ref.isOn,
    Icon = _ref.Icon;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('wrapper'),
    onClick: onClick,
    "data-t-id": "PaymentDetailsSection-Toggle"
  }, /*#__PURE__*/React.createElement("span", {
    className: cn('icon'),
    style: {
      backgroundImage: "url(".concat(iconUrl, ")")
    }
  }, Icon && /*#__PURE__*/React.createElement(Icon, null)), /*#__PURE__*/React.createElement("div", {
    className: cn('content')
  }, /*#__PURE__*/React.createElement(Text, {
    color: "primary",
    variant: "body-small"
  }, text.title), /*#__PURE__*/React.createElement(Text, {
    color: "secondary",
    variant: "body-small"
  }, text.subtitle)), /*#__PURE__*/React.createElement(Switch, {
    checked: isOn
  }));
};